<div class="header-container">
    <h1>Decision Maker Dashboard</h1>
    <nz-skeleton [nzLoading]="isCalculating" [nzParagraph]="{ rows: 0 }" [nzActive]="true">
        <h4>{{ dmPercent }} % of the decision makers have a frontegg user assigned to them ({{ fronteggCount }} / {{ dmList?.length }})</h4>
        <div>
            Total tenant count included in statistics {{ tenants?.length }} 
            <span nz-icon nzType="question-circle" nzTheme="outline"
                nz-tooltip="This is the number of total tenant count that are included in statistics,
                calculated values for decision maker are based on tenant activity"></span>
        </div>
    </nz-skeleton>
</div>
<div class="content">
    <nz-table nzTemplateMode [nzLoading]="isLoading" nzSize="small">
        <thead>
            <tr>
                <th rowSpan="2">Name</th>
                <th rowSpan="2">Email</th>
                <th rowSpan="2">Role</th>
                <th rowSpan="2">Is Frontegg User</th>
                <th colSpan="3">Activity</th>
                <th rowSpan="2">Tenant</th>
            </tr>
            <tr>
                <th>Last 24h</th>
                <th>Last 7d</th>
                <th>Last 30d</th>
            </tr>
        </thead>
        <tbody>
            @for (dm of dmList; track $index) {
            <tr>
                <td>{{ dm.decision_maker_name }}</td>
                <td>{{ dm.decision_maker_email }}</td>
                <td>{{ dm.decision_maker_role }}</td>
                <td>
                    <label nzDisabled nz-checkbox [(ngModel)]="dm.is_frontegg_user"></label>
                </td>
                @if(dm.is_frontegg_user) {
                    <td>{{ dm.count_24h }}</td>
                    <td>{{ dm.count_7d }}</td>
                    <td>{{ dm.count_30d }}</td>
                } @else {
                    <td colspan="3">NO ACCOUNT</td>
                }
                <td><button nz-button nzType="default" (click)="openTenant(dm.tenant_id)">
                        <span nz-icon nzType="link" nzTheme="outline"></span>
                        Linked tenant
                    </button>
                </td>
            </tr>
            }
        </tbody>
    </nz-table>
</div>